import * as constants from './constants'

const subscriptionsInitialState = {
    subscriptions: [],
    subscriptionInvoices: [],
    waitList: [],
}

export const reducer = (state = subscriptionsInitialState, action) => {
    switch (action.type) {
        case constants.SET_SUBSCRIPTIONS_HISTORY:
            return {
                ...state,
                subscriptions: action.data,
            }
        case constants.SET_SUBSCRIPTION_INVOICES:
            return {
                ...state,
                subscriptionInvoices: action.data,
            }
        case constants.SET_SUBSCRIPTION:
            let { subscriptions } = state
            const { updatedSubscription } = action

            if (updatedSubscription) {
                subscriptions = subscriptions.map(sub => {
                    if (sub.id === updatedSubscription.id) {
                        return updatedSubscription
                    }
                    return sub
                })
            }

            return {
                ...state,
                subscriptions,
            }
        case constants.SET_WAIT_LIST:
            return {
                ...state,
                waitList: action.waitList,
            }
        case constants.DELETE_WAIT_LIST_ITEM:
            return {
                ...state,
            }
        default:
            return state
    }
}
